import React from 'react';

import { useCompetencyDrawerState } from '../competencyDrawerSlice';
import { SecondaryDrawerScreens } from '../types/slice';
import { AddInitiativePanel } from './AddInitiativePanel';
import { GoalSelectionPanel } from './GoalSelectionPanel';
import { MeshMavenPanel } from './MeshMavenPanel';
import { RequestFeedbackPanel } from './RequestFeedbackPanel';
import { ShareFeedbackPanel } from './ShareFeedbackPanel';

const SecondaryScreenMap: Record<SecondaryDrawerScreens, React.FC> = {
  REQUEST_FEEDBACK: RequestFeedbackPanel,
  GOAL_SELECTION: GoalSelectionPanel,
  SHARE_FEEDBACK: ShareFeedbackPanel,
  MESH_MAVEN: MeshMavenPanel,
  ADD_INITIATIVE: AddInitiativePanel,
};

export const SecondaryPanelBody = () => {
  const { selectedSecondaryScreen } = useCompetencyDrawerState();

  const Component = SecondaryScreenMap[selectedSecondaryScreen];

  return Component ? <Component /> : null;
};
